import { takeEvery } from 'redux-saga';
import { call, put, take, select } from 'redux-saga/effects';
import * as api from 'api/adCreation';
import parseBgStockMusic from 'api/parsers/bgStockMusic';
import * as actions from 'actions/targeting';
import { SSO_SESSION_ACTIVE } from 'actions/auth';
import { getWgToken } from 'selectors/auth';
import { sortByKeyAsc } from 'utilities';
import { mapGenres } from 'mappers/genres';

export function* fetchGenres() {
  const { accessToken } = yield take(SSO_SESSION_ACTIVE);

  try {
    const genres = yield call(api.fetchTargeting, api.GENRE, accessToken);
    const mappedGenres = mapGenres(sortByKeyAsc('name', genres));
    yield put(actions.fetchGenresSuccess(mappedGenres));
  } catch (e) {
    yield put(actions.fetchGenresFailed(e));
  }
}

export function* fetchPlaylistCategories() {
  const { accessToken } = yield take(SSO_SESSION_ACTIVE);

  try {
    const categories = yield call(api.fetchTargeting, api.PLAYLIST_CAT, accessToken);
    yield put(actions.fetchPlaylistCategoriesSuccess(sortByKeyAsc('name', categories)));
  } catch (e) {
    yield put(actions.fetchPlaylistCategoriesFailed(e));
  }
}

export function* fetchGeos() {
  const { accessToken } = yield take(SSO_SESSION_ACTIVE);

  try {
    const geos = yield call(api.fetchTargeting, api.GEO, accessToken);
    yield put(actions.fetchGeosSuccess(sortByKeyAsc('name', geos)));
  } catch (e) {
    yield put(actions.fetchGeosFailed(e));
  }
}

export function* fetchStockMusic() {
  const wgToken = yield select(getWgToken);

  try {
    const tracks = yield call(api.fetchStockMusic, wgToken);
    yield put(actions.fetchStockMusicSuccess(sortByKeyAsc('name', tracks.map(parseBgStockMusic))));
  } catch (e) {
    yield put(actions.fetchStockMusicFailed(e));
  }
}

export function* watchStockMusicFetch() {
  yield takeEvery(actions.FETCH_STOCK_MUSIC_REQUESTED, fetchStockMusic);
}

export function* fetchTargetingItems() {
  yield [
    fetchGenres(),
    fetchPlaylistCategories(),
    fetchGeos(),
  ];
}



// WEBPACK FOOTER //
// ./src/middleware/sagas/targeting.js